import { render, staticRenderFns } from "./AdminWorkspaceStats.vue?vue&type=template&id=1515940f"
import script from "./AdminWorkspaceStats.vue?vue&type=script&lang=ts"
export * from "./AdminWorkspaceStats.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports